export default __webpack_public_path__ + "static/media/1963.46c3470d.png";